module.exports = __webpack_public_path__ + "img/Truppführer_MHP.ebf2c155.svg";